"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RingHandler = void 0;
var _gsap = _interopRequireDefault(require("gsap"));
var _Ring = require("./Ring");
var _color = _interopRequireDefault(require("color"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var RingHandler = exports.RingHandler = /*#__PURE__*/function () {
  function RingHandler(renderer) {
    _classCallCheck(this, RingHandler);
    _defineProperty(this, "_ring", void 0);
    _defineProperty(this, "path", void 0);
    _defineProperty(this, "renderer", void 0);
    this._ring = null;
    this.path = "/assets/image";
    this.renderer = renderer;
  }
  return _createClass(RingHandler, [{
    key: "setAssetsPath",
    value: function setAssetsPath(path) {
      this.path = path;
    }
  }, {
    key: "load",
    value: function load(cb) {}
  }, {
    key: "createRing",
    value: function createRing(params) {
      this._ring = new _Ring.Ring(params, this.renderer);
      return this._ring;
    }
  }, {
    key: "ring",
    get: function get() {
      return this._ring;
    }
  }, {
    key: "setPrice",
    value: function setPrice(number) {
      if (!this._ring) {
        return;
      }
      this._ring.setPrice(number);
    }
  }, {
    key: "setText",
    value: function setText(text) {
      if (!this._ring) {
        return;
      }
      this._ring.setText(text);
    }
  }, {
    key: "flyText",
    value: function flyText(text) {
      if (!this._ring) {
        return;
      }
      this._ring.flyText(text);
    }
  }, {
    key: "colorChange",
    value: function colorChange(isBonus, poop) {
      var _this = this;
      if (!this._ring) {
        return;
      }
      var startColor = (0, _color["default"])(0x686bec).hsl().object();
      _gsap["default"].killTweensOf(this.ring.aura.tintHsl);
      if (isBonus) {
        _gsap["default"].to(this.ring.aura.tintHsl, {
          duration: 0.5,
          h: 315,
          s: 200,
          ease: 'power1.out',
          onUpdate: function onUpdate() {
            _this.ring.aura.tint = (0, _color["default"])({
              h: _this.ring.aura.tintHsl.h,
              s: _this.ring.aura.tintHsl.s,
              l: _this.ring.aura.tintHsl.l
            }).rgbNumber();
          }
        });
      } else if (poop) {
        _gsap["default"].to(this.ring.aura.tintHsl, {
          duration: 0.5,
          h: 123,
          s: 200,
          l: 37,
          ease: 'power1.out',
          onUpdate: function onUpdate() {
            _this.ring.aura.tint = (0, _color["default"])({
              h: _this.ring.aura.tintHsl.h,
              s: _this.ring.aura.tintHsl.s,
              l: _this.ring.aura.tintHsl.l
            }).rgbNumber();
          }
        });
      } else {
        _gsap["default"].to(this.ring.aura.tintHsl, {
          duration: 0.5,
          h: startColor.h,
          s: startColor.s,
          ease: 'power1.out',
          delay: 0.6,
          onUpdate: function onUpdate() {
            _this.ring.aura.tint = (0, _color["default"])({
              h: _this.ring.aura.tintHsl.h,
              s: _this.ring.aura.tintHsl.s,
              l: _this.ring.aura.tintHsl.l
            }).rgbNumber();
          }
        });
      }
    }
  }, {
    key: "pulse",
    value: function pulse(win) {
      if (!this._ring) {
        return;
      }
      _gsap["default"].killTweensOf(this.ring.text.scale);
      _gsap["default"].to(this.ring.text.scale, {
        duration: 0.25,
        x: this.ring.text["originalScale"] + (win ? 0.4 : 0.1),
        y: this.ring.text["originalScale"] + (win ? 0.4 : 0.1),
        ease: 'power1.out'
      });
      _gsap["default"].to(this.ring.text.scale, {
        duration: 0.25,
        x: this.ring.text["originalScale"],
        y: this.ring.text["originalScale"],
        delay: 0.35,
        ease: 'power1.out'
      });
      _gsap["default"].killTweensOf(this.ring.backSprite.scale);
      _gsap["default"].to(this.ring.backSprite.scale, {
        duration: 0.25,
        x: win ? 1.15 : 1.075,
        y: win ? 1.15 : 1.075,
        ease: 'power1.out'
      });
      _gsap["default"].to(this.ring.backSprite.scale, {
        duration: 0.25,
        x: 1,
        y: 1,
        delay: 0.35,
        ease: 'power1.out'
      });
      _gsap["default"].killTweensOf(this.ring.colorBg.scale);
      _gsap["default"].to(this.ring.colorBg.scale, {
        duration: 0.25,
        x: win ? 1.15 : 1.075,
        y: win ? 1.15 : 1.075,
        ease: 'power1.out'
      });
      _gsap["default"].to(this.ring.colorBg.scale, {
        duration: 0.25,
        x: 1,
        y: 1,
        delay: 0.35,
        ease: 'power1.out'
      });
      if (win) {
        this.ring.particles.spawn();
      }
    }
  }, {
    key: "status",
    value: function status(running) {
      if (!this._ring) {
        return;
      }
      if (running) {
        _gsap["default"].killTweensOf(this.ring);
        _gsap["default"].to(this.ring, {
          duration: 0.5,
          alpha: 1,
          ease: 'power1.out'
        });
      } else {
        _gsap["default"].killTweensOf(this.ring);
        _gsap["default"].to(this.ring, {
          duration: 0.25,
          alpha: 0,
          ease: 'power1.out'
        });
      }
    }
  }]);
}();
//# sourceMappingURL=RingHandler.js.map